// src/ContactUs.js
import React from 'react';
import './Contact.css';

const Contact = () => {
    return (
        <div className="contact-us">
            <div className="contact-us-content">
                <h1>CONTACT US</h1>
                <p>We love to hear from you! Let us know how we can help.</p>
                <p>Email us at <a href="mailto:zwdininggroupllc@gmail.com">zwdininggroupllc@gmail.com</a></p>
            </div>
        </div>
    );
}

export default Contact;
